module.exports = function($){
  $.FW   = true;
  $.path = $.g;
  return $;
};